/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import $protobuf from "protobufjs/minimal.js";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const squarediot = $root.squarediot = (() => {

    /**
     * Namespace squarediot.
     * @exports squarediot
     * @namespace
     */
    const squarediot = {};

    squarediot.v1 = (function() {

        /**
         * Namespace v1.
         * @memberof squarediot
         * @namespace
         */
        const v1 = {};

        v1.Heartbeat = (function() {

            /**
             * Properties of a Heartbeat.
             * @memberof squarediot.v1
             * @interface IHeartbeat
             * @property {number|null} [uptimeS] Heartbeat uptimeS
             * @property {squarediot.v1.CellularState|null} [cellState] Heartbeat cellState
             * @property {number|null} [rssiDbm] Heartbeat rssiDbm
             * @property {number|null} [rsrpDbm] Heartbeat rsrpDbm
             * @property {number|null} [rsrqDb] Heartbeat rsrqDb
             * @property {number|null} [upSecondsRun] Heartbeat upSecondsRun
             * @property {number|null} [downSecondsRun] Heartbeat downSecondsRun
             * @property {number|null} [recoveriesL0] Heartbeat recoveriesL0
             * @property {number|null} [recoveriesL1] Heartbeat recoveriesL1
             * @property {number|null} [recoveriesL2] Heartbeat recoveriesL2
             * @property {number|null} [recoveriesL3] Heartbeat recoveriesL3
             * @property {number|null} [bootCount] Heartbeat bootCount
             * @property {number|null} [mqttDisconnectsLife] Heartbeat mqttDisconnectsLife
             * @property {number|null} [modemRestartsLife] Heartbeat modemRestartsLife
             * @property {number|null} [lifetimeUptimeS] Heartbeat lifetimeUptimeS
             * @property {number|Long|null} [wallclock] Heartbeat wallclock
             * @property {number|null} [lastResetReason] Heartbeat lastResetReason
             * @property {Array.<squarediot.v1.IActuatorState>|null} [actuators] Heartbeat actuators
             * @property {number|null} [seq] Heartbeat seq
             */

            /**
             * Constructs a new Heartbeat.
             * @memberof squarediot.v1
             * @classdesc Represents a Heartbeat.
             * @implements IHeartbeat
             * @constructor
             * @param {squarediot.v1.IHeartbeat=} [properties] Properties to set
             */
            function Heartbeat(properties) {
                this.actuators = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Heartbeat uptimeS.
             * @member {number} uptimeS
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.uptimeS = 0;

            /**
             * Heartbeat cellState.
             * @member {squarediot.v1.CellularState} cellState
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.cellState = 0;

            /**
             * Heartbeat rssiDbm.
             * @member {number} rssiDbm
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.rssiDbm = 0;

            /**
             * Heartbeat rsrpDbm.
             * @member {number} rsrpDbm
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.rsrpDbm = 0;

            /**
             * Heartbeat rsrqDb.
             * @member {number} rsrqDb
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.rsrqDb = 0;

            /**
             * Heartbeat upSecondsRun.
             * @member {number} upSecondsRun
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.upSecondsRun = 0;

            /**
             * Heartbeat downSecondsRun.
             * @member {number} downSecondsRun
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.downSecondsRun = 0;

            /**
             * Heartbeat recoveriesL0.
             * @member {number} recoveriesL0
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.recoveriesL0 = 0;

            /**
             * Heartbeat recoveriesL1.
             * @member {number} recoveriesL1
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.recoveriesL1 = 0;

            /**
             * Heartbeat recoveriesL2.
             * @member {number} recoveriesL2
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.recoveriesL2 = 0;

            /**
             * Heartbeat recoveriesL3.
             * @member {number} recoveriesL3
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.recoveriesL3 = 0;

            /**
             * Heartbeat bootCount.
             * @member {number} bootCount
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.bootCount = 0;

            /**
             * Heartbeat mqttDisconnectsLife.
             * @member {number} mqttDisconnectsLife
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.mqttDisconnectsLife = 0;

            /**
             * Heartbeat modemRestartsLife.
             * @member {number} modemRestartsLife
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.modemRestartsLife = 0;

            /**
             * Heartbeat lifetimeUptimeS.
             * @member {number} lifetimeUptimeS
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.lifetimeUptimeS = 0;

            /**
             * Heartbeat wallclock.
             * @member {number|Long} wallclock
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.wallclock = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Heartbeat lastResetReason.
             * @member {number} lastResetReason
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.lastResetReason = 0;

            /**
             * Heartbeat actuators.
             * @member {Array.<squarediot.v1.IActuatorState>} actuators
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.actuators = $util.emptyArray;

            /**
             * Heartbeat seq.
             * @member {number} seq
             * @memberof squarediot.v1.Heartbeat
             * @instance
             */
            Heartbeat.prototype.seq = 0;

            /**
             * Creates a new Heartbeat instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {squarediot.v1.IHeartbeat=} [properties] Properties to set
             * @returns {squarediot.v1.Heartbeat} Heartbeat instance
             */
            Heartbeat.create = function create(properties) {
                return new Heartbeat(properties);
            };

            /**
             * Encodes the specified Heartbeat message. Does not implicitly {@link squarediot.v1.Heartbeat.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {squarediot.v1.IHeartbeat} message Heartbeat message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Heartbeat.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uptimeS != null && Object.hasOwnProperty.call(message, "uptimeS"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uptimeS);
                if (message.cellState != null && Object.hasOwnProperty.call(message, "cellState"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cellState);
                if (message.rssiDbm != null && Object.hasOwnProperty.call(message, "rssiDbm"))
                    writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.rssiDbm);
                if (message.rsrpDbm != null && Object.hasOwnProperty.call(message, "rsrpDbm"))
                    writer.uint32(/* id 4, wireType 0 =*/32).sint32(message.rsrpDbm);
                if (message.rsrqDb != null && Object.hasOwnProperty.call(message, "rsrqDb"))
                    writer.uint32(/* id 5, wireType 0 =*/40).sint32(message.rsrqDb);
                if (message.upSecondsRun != null && Object.hasOwnProperty.call(message, "upSecondsRun"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.upSecondsRun);
                if (message.downSecondsRun != null && Object.hasOwnProperty.call(message, "downSecondsRun"))
                    writer.uint32(/* id 7, wireType 0 =*/56).uint32(message.downSecondsRun);
                if (message.recoveriesL0 != null && Object.hasOwnProperty.call(message, "recoveriesL0"))
                    writer.uint32(/* id 8, wireType 0 =*/64).uint32(message.recoveriesL0);
                if (message.recoveriesL1 != null && Object.hasOwnProperty.call(message, "recoveriesL1"))
                    writer.uint32(/* id 9, wireType 0 =*/72).uint32(message.recoveriesL1);
                if (message.recoveriesL2 != null && Object.hasOwnProperty.call(message, "recoveriesL2"))
                    writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.recoveriesL2);
                if (message.recoveriesL3 != null && Object.hasOwnProperty.call(message, "recoveriesL3"))
                    writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.recoveriesL3);
                if (message.bootCount != null && Object.hasOwnProperty.call(message, "bootCount"))
                    writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.bootCount);
                if (message.mqttDisconnectsLife != null && Object.hasOwnProperty.call(message, "mqttDisconnectsLife"))
                    writer.uint32(/* id 13, wireType 0 =*/104).uint32(message.mqttDisconnectsLife);
                if (message.modemRestartsLife != null && Object.hasOwnProperty.call(message, "modemRestartsLife"))
                    writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.modemRestartsLife);
                if (message.lifetimeUptimeS != null && Object.hasOwnProperty.call(message, "lifetimeUptimeS"))
                    writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.lifetimeUptimeS);
                if (message.wallclock != null && Object.hasOwnProperty.call(message, "wallclock"))
                    writer.uint32(/* id 16, wireType 0 =*/128).uint64(message.wallclock);
                if (message.lastResetReason != null && Object.hasOwnProperty.call(message, "lastResetReason"))
                    writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.lastResetReason);
                if (message.actuators != null && message.actuators.length)
                    for (let i = 0; i < message.actuators.length; ++i)
                        $root.squarediot.v1.ActuatorState.encode(message.actuators[i], writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                if (message.seq != null && Object.hasOwnProperty.call(message, "seq"))
                    writer.uint32(/* id 28, wireType 0 =*/224).uint32(message.seq);
                return writer;
            };

            /**
             * Encodes the specified Heartbeat message, length delimited. Does not implicitly {@link squarediot.v1.Heartbeat.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {squarediot.v1.IHeartbeat} message Heartbeat message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Heartbeat.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Heartbeat message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.Heartbeat} Heartbeat
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Heartbeat.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.Heartbeat();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.uptimeS = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.cellState = reader.int32();
                            break;
                        }
                    case 3: {
                            message.rssiDbm = reader.sint32();
                            break;
                        }
                    case 4: {
                            message.rsrpDbm = reader.sint32();
                            break;
                        }
                    case 5: {
                            message.rsrqDb = reader.sint32();
                            break;
                        }
                    case 6: {
                            message.upSecondsRun = reader.uint32();
                            break;
                        }
                    case 7: {
                            message.downSecondsRun = reader.uint32();
                            break;
                        }
                    case 8: {
                            message.recoveriesL0 = reader.uint32();
                            break;
                        }
                    case 9: {
                            message.recoveriesL1 = reader.uint32();
                            break;
                        }
                    case 10: {
                            message.recoveriesL2 = reader.uint32();
                            break;
                        }
                    case 11: {
                            message.recoveriesL3 = reader.uint32();
                            break;
                        }
                    case 12: {
                            message.bootCount = reader.uint32();
                            break;
                        }
                    case 13: {
                            message.mqttDisconnectsLife = reader.uint32();
                            break;
                        }
                    case 14: {
                            message.modemRestartsLife = reader.uint32();
                            break;
                        }
                    case 15: {
                            message.lifetimeUptimeS = reader.uint32();
                            break;
                        }
                    case 16: {
                            message.wallclock = reader.uint64();
                            break;
                        }
                    case 17: {
                            message.lastResetReason = reader.uint32();
                            break;
                        }
                    case 26: {
                            if (!(message.actuators && message.actuators.length))
                                message.actuators = [];
                            message.actuators.push($root.squarediot.v1.ActuatorState.decode(reader, reader.uint32(), undefined, long + 1));
                            break;
                        }
                    case 28: {
                            message.seq = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Heartbeat message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.Heartbeat} Heartbeat
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Heartbeat.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Heartbeat message.
             * @function verify
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Heartbeat.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.uptimeS != null && message.hasOwnProperty("uptimeS"))
                    if (!$util.isInteger(message.uptimeS))
                        return "uptimeS: integer expected";
                if (message.cellState != null && message.hasOwnProperty("cellState"))
                    switch (message.cellState) {
                    default:
                        return "cellState: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                        break;
                    }
                if (message.rssiDbm != null && message.hasOwnProperty("rssiDbm"))
                    if (!$util.isInteger(message.rssiDbm))
                        return "rssiDbm: integer expected";
                if (message.rsrpDbm != null && message.hasOwnProperty("rsrpDbm"))
                    if (!$util.isInteger(message.rsrpDbm))
                        return "rsrpDbm: integer expected";
                if (message.rsrqDb != null && message.hasOwnProperty("rsrqDb"))
                    if (!$util.isInteger(message.rsrqDb))
                        return "rsrqDb: integer expected";
                if (message.upSecondsRun != null && message.hasOwnProperty("upSecondsRun"))
                    if (!$util.isInteger(message.upSecondsRun))
                        return "upSecondsRun: integer expected";
                if (message.downSecondsRun != null && message.hasOwnProperty("downSecondsRun"))
                    if (!$util.isInteger(message.downSecondsRun))
                        return "downSecondsRun: integer expected";
                if (message.recoveriesL0 != null && message.hasOwnProperty("recoveriesL0"))
                    if (!$util.isInteger(message.recoveriesL0))
                        return "recoveriesL0: integer expected";
                if (message.recoveriesL1 != null && message.hasOwnProperty("recoveriesL1"))
                    if (!$util.isInteger(message.recoveriesL1))
                        return "recoveriesL1: integer expected";
                if (message.recoveriesL2 != null && message.hasOwnProperty("recoveriesL2"))
                    if (!$util.isInteger(message.recoveriesL2))
                        return "recoveriesL2: integer expected";
                if (message.recoveriesL3 != null && message.hasOwnProperty("recoveriesL3"))
                    if (!$util.isInteger(message.recoveriesL3))
                        return "recoveriesL3: integer expected";
                if (message.bootCount != null && message.hasOwnProperty("bootCount"))
                    if (!$util.isInteger(message.bootCount))
                        return "bootCount: integer expected";
                if (message.mqttDisconnectsLife != null && message.hasOwnProperty("mqttDisconnectsLife"))
                    if (!$util.isInteger(message.mqttDisconnectsLife))
                        return "mqttDisconnectsLife: integer expected";
                if (message.modemRestartsLife != null && message.hasOwnProperty("modemRestartsLife"))
                    if (!$util.isInteger(message.modemRestartsLife))
                        return "modemRestartsLife: integer expected";
                if (message.lifetimeUptimeS != null && message.hasOwnProperty("lifetimeUptimeS"))
                    if (!$util.isInteger(message.lifetimeUptimeS))
                        return "lifetimeUptimeS: integer expected";
                if (message.wallclock != null && message.hasOwnProperty("wallclock"))
                    if (!$util.isInteger(message.wallclock) && !(message.wallclock && $util.isInteger(message.wallclock.low) && $util.isInteger(message.wallclock.high)))
                        return "wallclock: integer|Long expected";
                if (message.lastResetReason != null && message.hasOwnProperty("lastResetReason"))
                    if (!$util.isInteger(message.lastResetReason))
                        return "lastResetReason: integer expected";
                if (message.actuators != null && message.hasOwnProperty("actuators")) {
                    if (!Array.isArray(message.actuators))
                        return "actuators: array expected";
                    for (let i = 0; i < message.actuators.length; ++i) {
                        let error = $root.squarediot.v1.ActuatorState.verify(message.actuators[i], long + 1);
                        if (error)
                            return "actuators." + error;
                    }
                }
                if (message.seq != null && message.hasOwnProperty("seq"))
                    if (!$util.isInteger(message.seq))
                        return "seq: integer expected";
                return null;
            };

            /**
             * Creates a Heartbeat message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.Heartbeat} Heartbeat
             */
            Heartbeat.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.Heartbeat)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.Heartbeat();
                if (object.uptimeS != null)
                    message.uptimeS = object.uptimeS >>> 0;
                switch (object.cellState) {
                default:
                    if (typeof object.cellState === "number") {
                        message.cellState = object.cellState;
                        break;
                    }
                    break;
                case "CELL_STATE_UNSPECIFIED":
                case 0:
                    message.cellState = 0;
                    break;
                case "CELL_STATE_DOWN":
                case 1:
                    message.cellState = 1;
                    break;
                case "CELL_STATE_BRINGING_UP":
                case 2:
                    message.cellState = 2;
                    break;
                case "CELL_STATE_UP":
                case 3:
                    message.cellState = 3;
                    break;
                case "CELL_STATE_RECOVERING":
                case 4:
                    message.cellState = 4;
                    break;
                }
                if (object.rssiDbm != null)
                    message.rssiDbm = object.rssiDbm | 0;
                if (object.rsrpDbm != null)
                    message.rsrpDbm = object.rsrpDbm | 0;
                if (object.rsrqDb != null)
                    message.rsrqDb = object.rsrqDb | 0;
                if (object.upSecondsRun != null)
                    message.upSecondsRun = object.upSecondsRun >>> 0;
                if (object.downSecondsRun != null)
                    message.downSecondsRun = object.downSecondsRun >>> 0;
                if (object.recoveriesL0 != null)
                    message.recoveriesL0 = object.recoveriesL0 >>> 0;
                if (object.recoveriesL1 != null)
                    message.recoveriesL1 = object.recoveriesL1 >>> 0;
                if (object.recoveriesL2 != null)
                    message.recoveriesL2 = object.recoveriesL2 >>> 0;
                if (object.recoveriesL3 != null)
                    message.recoveriesL3 = object.recoveriesL3 >>> 0;
                if (object.bootCount != null)
                    message.bootCount = object.bootCount >>> 0;
                if (object.mqttDisconnectsLife != null)
                    message.mqttDisconnectsLife = object.mqttDisconnectsLife >>> 0;
                if (object.modemRestartsLife != null)
                    message.modemRestartsLife = object.modemRestartsLife >>> 0;
                if (object.lifetimeUptimeS != null)
                    message.lifetimeUptimeS = object.lifetimeUptimeS >>> 0;
                if (object.wallclock != null)
                    if ($util.Long)
                        (message.wallclock = $util.Long.fromValue(object.wallclock)).unsigned = true;
                    else if (typeof object.wallclock === "string")
                        message.wallclock = parseInt(object.wallclock, 10);
                    else if (typeof object.wallclock === "number")
                        message.wallclock = object.wallclock;
                    else if (typeof object.wallclock === "object")
                        message.wallclock = new $util.LongBits(object.wallclock.low >>> 0, object.wallclock.high >>> 0).toNumber(true);
                if (object.lastResetReason != null)
                    message.lastResetReason = object.lastResetReason >>> 0;
                if (object.actuators) {
                    if (!Array.isArray(object.actuators))
                        throw TypeError(".squarediot.v1.Heartbeat.actuators: array expected");
                    message.actuators = [];
                    for (let i = 0; i < object.actuators.length; ++i) {
                        if (typeof object.actuators[i] !== "object")
                            throw TypeError(".squarediot.v1.Heartbeat.actuators: object expected");
                        message.actuators[i] = $root.squarediot.v1.ActuatorState.fromObject(object.actuators[i], long + 1);
                    }
                }
                if (object.seq != null)
                    message.seq = object.seq >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a Heartbeat message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {squarediot.v1.Heartbeat} message Heartbeat
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Heartbeat.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults)
                    object.actuators = [];
                if (options.defaults) {
                    object.uptimeS = 0;
                    object.cellState = options.enums === String ? "CELL_STATE_UNSPECIFIED" : 0;
                    object.rssiDbm = 0;
                    object.rsrpDbm = 0;
                    object.rsrqDb = 0;
                    object.upSecondsRun = 0;
                    object.downSecondsRun = 0;
                    object.recoveriesL0 = 0;
                    object.recoveriesL1 = 0;
                    object.recoveriesL2 = 0;
                    object.recoveriesL3 = 0;
                    object.bootCount = 0;
                    object.mqttDisconnectsLife = 0;
                    object.modemRestartsLife = 0;
                    object.lifetimeUptimeS = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.wallclock = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.wallclock = options.longs === String ? "0" : 0;
                    object.lastResetReason = 0;
                    object.seq = 0;
                }
                if (message.uptimeS != null && message.hasOwnProperty("uptimeS"))
                    object.uptimeS = message.uptimeS;
                if (message.cellState != null && message.hasOwnProperty("cellState"))
                    object.cellState = options.enums === String ? $root.squarediot.v1.CellularState[message.cellState] === undefined ? message.cellState : $root.squarediot.v1.CellularState[message.cellState] : message.cellState;
                if (message.rssiDbm != null && message.hasOwnProperty("rssiDbm"))
                    object.rssiDbm = message.rssiDbm;
                if (message.rsrpDbm != null && message.hasOwnProperty("rsrpDbm"))
                    object.rsrpDbm = message.rsrpDbm;
                if (message.rsrqDb != null && message.hasOwnProperty("rsrqDb"))
                    object.rsrqDb = message.rsrqDb;
                if (message.upSecondsRun != null && message.hasOwnProperty("upSecondsRun"))
                    object.upSecondsRun = message.upSecondsRun;
                if (message.downSecondsRun != null && message.hasOwnProperty("downSecondsRun"))
                    object.downSecondsRun = message.downSecondsRun;
                if (message.recoveriesL0 != null && message.hasOwnProperty("recoveriesL0"))
                    object.recoveriesL0 = message.recoveriesL0;
                if (message.recoveriesL1 != null && message.hasOwnProperty("recoveriesL1"))
                    object.recoveriesL1 = message.recoveriesL1;
                if (message.recoveriesL2 != null && message.hasOwnProperty("recoveriesL2"))
                    object.recoveriesL2 = message.recoveriesL2;
                if (message.recoveriesL3 != null && message.hasOwnProperty("recoveriesL3"))
                    object.recoveriesL3 = message.recoveriesL3;
                if (message.bootCount != null && message.hasOwnProperty("bootCount"))
                    object.bootCount = message.bootCount;
                if (message.mqttDisconnectsLife != null && message.hasOwnProperty("mqttDisconnectsLife"))
                    object.mqttDisconnectsLife = message.mqttDisconnectsLife;
                if (message.modemRestartsLife != null && message.hasOwnProperty("modemRestartsLife"))
                    object.modemRestartsLife = message.modemRestartsLife;
                if (message.lifetimeUptimeS != null && message.hasOwnProperty("lifetimeUptimeS"))
                    object.lifetimeUptimeS = message.lifetimeUptimeS;
                if (message.wallclock != null && message.hasOwnProperty("wallclock"))
                    if (typeof message.wallclock === "number")
                        object.wallclock = options.longs === String ? String(message.wallclock) : message.wallclock;
                    else
                        object.wallclock = options.longs === String ? $util.Long.prototype.toString.call(message.wallclock) : options.longs === Number ? new $util.LongBits(message.wallclock.low >>> 0, message.wallclock.high >>> 0).toNumber(true) : message.wallclock;
                if (message.lastResetReason != null && message.hasOwnProperty("lastResetReason"))
                    object.lastResetReason = message.lastResetReason;
                if (message.actuators && message.actuators.length) {
                    object.actuators = [];
                    for (let j = 0; j < message.actuators.length; ++j)
                        object.actuators[j] = $root.squarediot.v1.ActuatorState.toObject(message.actuators[j], options);
                }
                if (message.seq != null && message.hasOwnProperty("seq"))
                    object.seq = message.seq;
                return object;
            };

            /**
             * Converts this Heartbeat to JSON.
             * @function toJSON
             * @memberof squarediot.v1.Heartbeat
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Heartbeat.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Heartbeat
             * @function getTypeUrl
             * @memberof squarediot.v1.Heartbeat
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Heartbeat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.Heartbeat";
            };

            return Heartbeat;
        })();

        v1.ActuatorState = (function() {

            /**
             * Properties of an ActuatorState.
             * @memberof squarediot.v1
             * @interface IActuatorState
             * @property {number|null} [pin] ActuatorState pin
             * @property {boolean|null} [on] ActuatorState on
             */

            /**
             * Constructs a new ActuatorState.
             * @memberof squarediot.v1
             * @classdesc Represents an ActuatorState.
             * @implements IActuatorState
             * @constructor
             * @param {squarediot.v1.IActuatorState=} [properties] Properties to set
             */
            function ActuatorState(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ActuatorState pin.
             * @member {number} pin
             * @memberof squarediot.v1.ActuatorState
             * @instance
             */
            ActuatorState.prototype.pin = 0;

            /**
             * ActuatorState on.
             * @member {boolean} on
             * @memberof squarediot.v1.ActuatorState
             * @instance
             */
            ActuatorState.prototype.on = false;

            /**
             * Creates a new ActuatorState instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {squarediot.v1.IActuatorState=} [properties] Properties to set
             * @returns {squarediot.v1.ActuatorState} ActuatorState instance
             */
            ActuatorState.create = function create(properties) {
                return new ActuatorState(properties);
            };

            /**
             * Encodes the specified ActuatorState message. Does not implicitly {@link squarediot.v1.ActuatorState.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {squarediot.v1.IActuatorState} message ActuatorState message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ActuatorState.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pin);
                if (message.on != null && Object.hasOwnProperty.call(message, "on"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.on);
                return writer;
            };

            /**
             * Encodes the specified ActuatorState message, length delimited. Does not implicitly {@link squarediot.v1.ActuatorState.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {squarediot.v1.IActuatorState} message ActuatorState message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ActuatorState.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ActuatorState message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.ActuatorState} ActuatorState
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ActuatorState.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.ActuatorState();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.pin = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.on = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ActuatorState message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.ActuatorState} ActuatorState
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ActuatorState.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ActuatorState message.
             * @function verify
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ActuatorState.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.pin != null && message.hasOwnProperty("pin"))
                    if (!$util.isInteger(message.pin))
                        return "pin: integer expected";
                if (message.on != null && message.hasOwnProperty("on"))
                    if (typeof message.on !== "boolean")
                        return "on: boolean expected";
                return null;
            };

            /**
             * Creates an ActuatorState message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.ActuatorState} ActuatorState
             */
            ActuatorState.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.ActuatorState)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.ActuatorState();
                if (object.pin != null)
                    message.pin = object.pin >>> 0;
                if (object.on != null)
                    message.on = Boolean(object.on);
                return message;
            };

            /**
             * Creates a plain object from an ActuatorState message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {squarediot.v1.ActuatorState} message ActuatorState
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ActuatorState.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.pin = 0;
                    object.on = false;
                }
                if (message.pin != null && message.hasOwnProperty("pin"))
                    object.pin = message.pin;
                if (message.on != null && message.hasOwnProperty("on"))
                    object.on = message.on;
                return object;
            };

            /**
             * Converts this ActuatorState to JSON.
             * @function toJSON
             * @memberof squarediot.v1.ActuatorState
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ActuatorState.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ActuatorState
             * @function getTypeUrl
             * @memberof squarediot.v1.ActuatorState
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ActuatorState.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.ActuatorState";
            };

            return ActuatorState;
        })();

        /**
         * CellularState enum.
         * @name squarediot.v1.CellularState
         * @enum {number}
         * @property {number} CELL_STATE_UNSPECIFIED=0 CELL_STATE_UNSPECIFIED value
         * @property {number} CELL_STATE_DOWN=1 CELL_STATE_DOWN value
         * @property {number} CELL_STATE_BRINGING_UP=2 CELL_STATE_BRINGING_UP value
         * @property {number} CELL_STATE_UP=3 CELL_STATE_UP value
         * @property {number} CELL_STATE_RECOVERING=4 CELL_STATE_RECOVERING value
         */
        v1.CellularState = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "CELL_STATE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "CELL_STATE_DOWN"] = 1;
            values[valuesById[2] = "CELL_STATE_BRINGING_UP"] = 2;
            values[valuesById[3] = "CELL_STATE_UP"] = 3;
            values[valuesById[4] = "CELL_STATE_RECOVERING"] = 4;
            return values;
        })();

        v1.DeviceInfo = (function() {

            /**
             * Properties of a DeviceInfo.
             * @memberof squarediot.v1
             * @interface IDeviceInfo
             * @property {string|null} [fwVersion] DeviceInfo fwVersion
             * @property {string|null} [hwVersion] DeviceInfo hwVersion
             * @property {string|null} [imei] DeviceInfo imei
             * @property {string|null} [iccid] DeviceInfo iccid
             * @property {string|null} [operatorName] DeviceInfo operatorName
             * @property {number|Long|null} [bootWallclock] DeviceInfo bootWallclock
             */

            /**
             * Constructs a new DeviceInfo.
             * @memberof squarediot.v1
             * @classdesc Represents a DeviceInfo.
             * @implements IDeviceInfo
             * @constructor
             * @param {squarediot.v1.IDeviceInfo=} [properties] Properties to set
             */
            function DeviceInfo(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DeviceInfo fwVersion.
             * @member {string} fwVersion
             * @memberof squarediot.v1.DeviceInfo
             * @instance
             */
            DeviceInfo.prototype.fwVersion = "";

            /**
             * DeviceInfo hwVersion.
             * @member {string} hwVersion
             * @memberof squarediot.v1.DeviceInfo
             * @instance
             */
            DeviceInfo.prototype.hwVersion = "";

            /**
             * DeviceInfo imei.
             * @member {string} imei
             * @memberof squarediot.v1.DeviceInfo
             * @instance
             */
            DeviceInfo.prototype.imei = "";

            /**
             * DeviceInfo iccid.
             * @member {string} iccid
             * @memberof squarediot.v1.DeviceInfo
             * @instance
             */
            DeviceInfo.prototype.iccid = "";

            /**
             * DeviceInfo operatorName.
             * @member {string} operatorName
             * @memberof squarediot.v1.DeviceInfo
             * @instance
             */
            DeviceInfo.prototype.operatorName = "";

            /**
             * DeviceInfo bootWallclock.
             * @member {number|Long} bootWallclock
             * @memberof squarediot.v1.DeviceInfo
             * @instance
             */
            DeviceInfo.prototype.bootWallclock = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new DeviceInfo instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {squarediot.v1.IDeviceInfo=} [properties] Properties to set
             * @returns {squarediot.v1.DeviceInfo} DeviceInfo instance
             */
            DeviceInfo.create = function create(properties) {
                return new DeviceInfo(properties);
            };

            /**
             * Encodes the specified DeviceInfo message. Does not implicitly {@link squarediot.v1.DeviceInfo.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {squarediot.v1.IDeviceInfo} message DeviceInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fwVersion != null && Object.hasOwnProperty.call(message, "fwVersion"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.fwVersion);
                if (message.hwVersion != null && Object.hasOwnProperty.call(message, "hwVersion"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.hwVersion);
                if (message.imei != null && Object.hasOwnProperty.call(message, "imei"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.imei);
                if (message.iccid != null && Object.hasOwnProperty.call(message, "iccid"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.iccid);
                if (message.operatorName != null && Object.hasOwnProperty.call(message, "operatorName"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.operatorName);
                if (message.bootWallclock != null && Object.hasOwnProperty.call(message, "bootWallclock"))
                    writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.bootWallclock);
                return writer;
            };

            /**
             * Encodes the specified DeviceInfo message, length delimited. Does not implicitly {@link squarediot.v1.DeviceInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {squarediot.v1.IDeviceInfo} message DeviceInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DeviceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DeviceInfo message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.DeviceInfo} DeviceInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceInfo.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.DeviceInfo();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.fwVersion = reader.string();
                            break;
                        }
                    case 2: {
                            message.hwVersion = reader.string();
                            break;
                        }
                    case 3: {
                            message.imei = reader.string();
                            break;
                        }
                    case 4: {
                            message.iccid = reader.string();
                            break;
                        }
                    case 5: {
                            message.operatorName = reader.string();
                            break;
                        }
                    case 6: {
                            message.bootWallclock = reader.uint64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DeviceInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.DeviceInfo} DeviceInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DeviceInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DeviceInfo message.
             * @function verify
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DeviceInfo.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.fwVersion != null && message.hasOwnProperty("fwVersion"))
                    if (!$util.isString(message.fwVersion))
                        return "fwVersion: string expected";
                if (message.hwVersion != null && message.hasOwnProperty("hwVersion"))
                    if (!$util.isString(message.hwVersion))
                        return "hwVersion: string expected";
                if (message.imei != null && message.hasOwnProperty("imei"))
                    if (!$util.isString(message.imei))
                        return "imei: string expected";
                if (message.iccid != null && message.hasOwnProperty("iccid"))
                    if (!$util.isString(message.iccid))
                        return "iccid: string expected";
                if (message.operatorName != null && message.hasOwnProperty("operatorName"))
                    if (!$util.isString(message.operatorName))
                        return "operatorName: string expected";
                if (message.bootWallclock != null && message.hasOwnProperty("bootWallclock"))
                    if (!$util.isInteger(message.bootWallclock) && !(message.bootWallclock && $util.isInteger(message.bootWallclock.low) && $util.isInteger(message.bootWallclock.high)))
                        return "bootWallclock: integer|Long expected";
                return null;
            };

            /**
             * Creates a DeviceInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.DeviceInfo} DeviceInfo
             */
            DeviceInfo.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.DeviceInfo)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.DeviceInfo();
                if (object.fwVersion != null)
                    message.fwVersion = String(object.fwVersion);
                if (object.hwVersion != null)
                    message.hwVersion = String(object.hwVersion);
                if (object.imei != null)
                    message.imei = String(object.imei);
                if (object.iccid != null)
                    message.iccid = String(object.iccid);
                if (object.operatorName != null)
                    message.operatorName = String(object.operatorName);
                if (object.bootWallclock != null)
                    if ($util.Long)
                        (message.bootWallclock = $util.Long.fromValue(object.bootWallclock)).unsigned = true;
                    else if (typeof object.bootWallclock === "string")
                        message.bootWallclock = parseInt(object.bootWallclock, 10);
                    else if (typeof object.bootWallclock === "number")
                        message.bootWallclock = object.bootWallclock;
                    else if (typeof object.bootWallclock === "object")
                        message.bootWallclock = new $util.LongBits(object.bootWallclock.low >>> 0, object.bootWallclock.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a DeviceInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {squarediot.v1.DeviceInfo} message DeviceInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DeviceInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.fwVersion = "";
                    object.hwVersion = "";
                    object.imei = "";
                    object.iccid = "";
                    object.operatorName = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.bootWallclock = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.bootWallclock = options.longs === String ? "0" : 0;
                }
                if (message.fwVersion != null && message.hasOwnProperty("fwVersion"))
                    object.fwVersion = message.fwVersion;
                if (message.hwVersion != null && message.hasOwnProperty("hwVersion"))
                    object.hwVersion = message.hwVersion;
                if (message.imei != null && message.hasOwnProperty("imei"))
                    object.imei = message.imei;
                if (message.iccid != null && message.hasOwnProperty("iccid"))
                    object.iccid = message.iccid;
                if (message.operatorName != null && message.hasOwnProperty("operatorName"))
                    object.operatorName = message.operatorName;
                if (message.bootWallclock != null && message.hasOwnProperty("bootWallclock"))
                    if (typeof message.bootWallclock === "number")
                        object.bootWallclock = options.longs === String ? String(message.bootWallclock) : message.bootWallclock;
                    else
                        object.bootWallclock = options.longs === String ? $util.Long.prototype.toString.call(message.bootWallclock) : options.longs === Number ? new $util.LongBits(message.bootWallclock.low >>> 0, message.bootWallclock.high >>> 0).toNumber(true) : message.bootWallclock;
                return object;
            };

            /**
             * Converts this DeviceInfo to JSON.
             * @function toJSON
             * @memberof squarediot.v1.DeviceInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DeviceInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for DeviceInfo
             * @function getTypeUrl
             * @memberof squarediot.v1.DeviceInfo
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            DeviceInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.DeviceInfo";
            };

            return DeviceInfo;
        })();

        v1.Status = (function() {

            /**
             * Properties of a Status.
             * @memberof squarediot.v1
             * @interface IStatus
             * @property {boolean|null} [online] Status online
             * @property {number|Long|null} [wallclock] Status wallclock
             * @property {number|null} [bootCount] Status bootCount
             */

            /**
             * Constructs a new Status.
             * @memberof squarediot.v1
             * @classdesc Represents a Status.
             * @implements IStatus
             * @constructor
             * @param {squarediot.v1.IStatus=} [properties] Properties to set
             */
            function Status(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Status online.
             * @member {boolean} online
             * @memberof squarediot.v1.Status
             * @instance
             */
            Status.prototype.online = false;

            /**
             * Status wallclock.
             * @member {number|Long} wallclock
             * @memberof squarediot.v1.Status
             * @instance
             */
            Status.prototype.wallclock = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Status bootCount.
             * @member {number} bootCount
             * @memberof squarediot.v1.Status
             * @instance
             */
            Status.prototype.bootCount = 0;

            /**
             * Creates a new Status instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.Status
             * @static
             * @param {squarediot.v1.IStatus=} [properties] Properties to set
             * @returns {squarediot.v1.Status} Status instance
             */
            Status.create = function create(properties) {
                return new Status(properties);
            };

            /**
             * Encodes the specified Status message. Does not implicitly {@link squarediot.v1.Status.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.Status
             * @static
             * @param {squarediot.v1.IStatus} message Status message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Status.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.online != null && Object.hasOwnProperty.call(message, "online"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.online);
                if (message.wallclock != null && Object.hasOwnProperty.call(message, "wallclock"))
                    writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.wallclock);
                if (message.bootCount != null && Object.hasOwnProperty.call(message, "bootCount"))
                    writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.bootCount);
                return writer;
            };

            /**
             * Encodes the specified Status message, length delimited. Does not implicitly {@link squarediot.v1.Status.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.Status
             * @static
             * @param {squarediot.v1.IStatus} message Status message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Status.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Status message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Status.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.Status();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.online = reader.bool();
                            break;
                        }
                    case 2: {
                            message.wallclock = reader.uint64();
                            break;
                        }
                    case 3: {
                            message.bootCount = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Status message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Status.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Status message.
             * @function verify
             * @memberof squarediot.v1.Status
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Status.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.online != null && message.hasOwnProperty("online"))
                    if (typeof message.online !== "boolean")
                        return "online: boolean expected";
                if (message.wallclock != null && message.hasOwnProperty("wallclock"))
                    if (!$util.isInteger(message.wallclock) && !(message.wallclock && $util.isInteger(message.wallclock.low) && $util.isInteger(message.wallclock.high)))
                        return "wallclock: integer|Long expected";
                if (message.bootCount != null && message.hasOwnProperty("bootCount"))
                    if (!$util.isInteger(message.bootCount))
                        return "bootCount: integer expected";
                return null;
            };

            /**
             * Creates a Status message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.Status
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.Status} Status
             */
            Status.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.Status)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.Status();
                if (object.online != null)
                    message.online = Boolean(object.online);
                if (object.wallclock != null)
                    if ($util.Long)
                        (message.wallclock = $util.Long.fromValue(object.wallclock)).unsigned = true;
                    else if (typeof object.wallclock === "string")
                        message.wallclock = parseInt(object.wallclock, 10);
                    else if (typeof object.wallclock === "number")
                        message.wallclock = object.wallclock;
                    else if (typeof object.wallclock === "object")
                        message.wallclock = new $util.LongBits(object.wallclock.low >>> 0, object.wallclock.high >>> 0).toNumber(true);
                if (object.bootCount != null)
                    message.bootCount = object.bootCount >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a Status message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.Status
             * @static
             * @param {squarediot.v1.Status} message Status
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Status.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.online = false;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, true);
                        object.wallclock = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.wallclock = options.longs === String ? "0" : 0;
                    object.bootCount = 0;
                }
                if (message.online != null && message.hasOwnProperty("online"))
                    object.online = message.online;
                if (message.wallclock != null && message.hasOwnProperty("wallclock"))
                    if (typeof message.wallclock === "number")
                        object.wallclock = options.longs === String ? String(message.wallclock) : message.wallclock;
                    else
                        object.wallclock = options.longs === String ? $util.Long.prototype.toString.call(message.wallclock) : options.longs === Number ? new $util.LongBits(message.wallclock.low >>> 0, message.wallclock.high >>> 0).toNumber(true) : message.wallclock;
                if (message.bootCount != null && message.hasOwnProperty("bootCount"))
                    object.bootCount = message.bootCount;
                return object;
            };

            /**
             * Converts this Status to JSON.
             * @function toJSON
             * @memberof squarediot.v1.Status
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Status.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Status
             * @function getTypeUrl
             * @memberof squarediot.v1.Status
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Status.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.Status";
            };

            return Status;
        })();

        v1.Command = (function() {

            /**
             * Properties of a Command.
             * @memberof squarediot.v1
             * @interface ICommand
             * @property {squarediot.v1.IResetMetricsCmd|null} [resetMetrics] Command resetMetrics
             * @property {squarediot.v1.IRebootCmd|null} [reboot] Command reboot
             * @property {squarediot.v1.ISetConfigCmd|null} [setConfig] Command setConfig
             * @property {squarediot.v1.ISetActuatorCmd|null} [setActuator] Command setActuator
             * @property {squarediot.v1.IToggleActuatorCmd|null} [toggleActuator] Command toggleActuator
             * @property {squarediot.v1.IResetActuatorsCmd|null} [resetActuators] Command resetActuators
             * @property {squarediot.v1.IRequestStatusCmd|null} [requestStatus] Command requestStatus
             */

            /**
             * Constructs a new Command.
             * @memberof squarediot.v1
             * @classdesc Represents a Command.
             * @implements ICommand
             * @constructor
             * @param {squarediot.v1.ICommand=} [properties] Properties to set
             */
            function Command(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Command resetMetrics.
             * @member {squarediot.v1.IResetMetricsCmd|null|undefined} resetMetrics
             * @memberof squarediot.v1.Command
             * @instance
             */
            Command.prototype.resetMetrics = null;

            /**
             * Command reboot.
             * @member {squarediot.v1.IRebootCmd|null|undefined} reboot
             * @memberof squarediot.v1.Command
             * @instance
             */
            Command.prototype.reboot = null;

            /**
             * Command setConfig.
             * @member {squarediot.v1.ISetConfigCmd|null|undefined} setConfig
             * @memberof squarediot.v1.Command
             * @instance
             */
            Command.prototype.setConfig = null;

            /**
             * Command setActuator.
             * @member {squarediot.v1.ISetActuatorCmd|null|undefined} setActuator
             * @memberof squarediot.v1.Command
             * @instance
             */
            Command.prototype.setActuator = null;

            /**
             * Command toggleActuator.
             * @member {squarediot.v1.IToggleActuatorCmd|null|undefined} toggleActuator
             * @memberof squarediot.v1.Command
             * @instance
             */
            Command.prototype.toggleActuator = null;

            /**
             * Command resetActuators.
             * @member {squarediot.v1.IResetActuatorsCmd|null|undefined} resetActuators
             * @memberof squarediot.v1.Command
             * @instance
             */
            Command.prototype.resetActuators = null;

            /**
             * Command requestStatus.
             * @member {squarediot.v1.IRequestStatusCmd|null|undefined} requestStatus
             * @memberof squarediot.v1.Command
             * @instance
             */
            Command.prototype.requestStatus = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            /**
             * Command op.
             * @member {"resetMetrics"|"reboot"|"setConfig"|"setActuator"|"toggleActuator"|"resetActuators"|"requestStatus"|undefined} op
             * @memberof squarediot.v1.Command
             * @instance
             */
            Object.defineProperty(Command.prototype, "op", {
                get: $util.oneOfGetter($oneOfFields = ["resetMetrics", "reboot", "setConfig", "setActuator", "toggleActuator", "resetActuators", "requestStatus"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new Command instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.Command
             * @static
             * @param {squarediot.v1.ICommand=} [properties] Properties to set
             * @returns {squarediot.v1.Command} Command instance
             */
            Command.create = function create(properties) {
                return new Command(properties);
            };

            /**
             * Encodes the specified Command message. Does not implicitly {@link squarediot.v1.Command.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.Command
             * @static
             * @param {squarediot.v1.ICommand} message Command message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Command.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.resetMetrics != null && Object.hasOwnProperty.call(message, "resetMetrics"))
                    $root.squarediot.v1.ResetMetricsCmd.encode(message.resetMetrics, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.reboot != null && Object.hasOwnProperty.call(message, "reboot"))
                    $root.squarediot.v1.RebootCmd.encode(message.reboot, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.setConfig != null && Object.hasOwnProperty.call(message, "setConfig"))
                    $root.squarediot.v1.SetConfigCmd.encode(message.setConfig, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.setActuator != null && Object.hasOwnProperty.call(message, "setActuator"))
                    $root.squarediot.v1.SetActuatorCmd.encode(message.setActuator, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.toggleActuator != null && Object.hasOwnProperty.call(message, "toggleActuator"))
                    $root.squarediot.v1.ToggleActuatorCmd.encode(message.toggleActuator, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.resetActuators != null && Object.hasOwnProperty.call(message, "resetActuators"))
                    $root.squarediot.v1.ResetActuatorsCmd.encode(message.resetActuators, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.requestStatus != null && Object.hasOwnProperty.call(message, "requestStatus"))
                    $root.squarediot.v1.RequestStatusCmd.encode(message.requestStatus, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Command message, length delimited. Does not implicitly {@link squarediot.v1.Command.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.Command
             * @static
             * @param {squarediot.v1.ICommand} message Command message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Command.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Command message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.Command
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.Command} Command
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Command.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.Command();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.resetMetrics = $root.squarediot.v1.ResetMetricsCmd.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 2: {
                            message.reboot = $root.squarediot.v1.RebootCmd.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 3: {
                            message.setConfig = $root.squarediot.v1.SetConfigCmd.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 4: {
                            message.setActuator = $root.squarediot.v1.SetActuatorCmd.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 5: {
                            message.toggleActuator = $root.squarediot.v1.ToggleActuatorCmd.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 6: {
                            message.resetActuators = $root.squarediot.v1.ResetActuatorsCmd.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    case 7: {
                            message.requestStatus = $root.squarediot.v1.RequestStatusCmd.decode(reader, reader.uint32(), undefined, long + 1);
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Command message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.Command
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.Command} Command
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Command.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Command message.
             * @function verify
             * @memberof squarediot.v1.Command
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Command.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                let properties = {};
                if (message.resetMetrics != null && message.hasOwnProperty("resetMetrics")) {
                    properties.op = 1;
                    {
                        let error = $root.squarediot.v1.ResetMetricsCmd.verify(message.resetMetrics, long + 1);
                        if (error)
                            return "resetMetrics." + error;
                    }
                }
                if (message.reboot != null && message.hasOwnProperty("reboot")) {
                    if (properties.op === 1)
                        return "op: multiple values";
                    properties.op = 1;
                    {
                        let error = $root.squarediot.v1.RebootCmd.verify(message.reboot, long + 1);
                        if (error)
                            return "reboot." + error;
                    }
                }
                if (message.setConfig != null && message.hasOwnProperty("setConfig")) {
                    if (properties.op === 1)
                        return "op: multiple values";
                    properties.op = 1;
                    {
                        let error = $root.squarediot.v1.SetConfigCmd.verify(message.setConfig, long + 1);
                        if (error)
                            return "setConfig." + error;
                    }
                }
                if (message.setActuator != null && message.hasOwnProperty("setActuator")) {
                    if (properties.op === 1)
                        return "op: multiple values";
                    properties.op = 1;
                    {
                        let error = $root.squarediot.v1.SetActuatorCmd.verify(message.setActuator, long + 1);
                        if (error)
                            return "setActuator." + error;
                    }
                }
                if (message.toggleActuator != null && message.hasOwnProperty("toggleActuator")) {
                    if (properties.op === 1)
                        return "op: multiple values";
                    properties.op = 1;
                    {
                        let error = $root.squarediot.v1.ToggleActuatorCmd.verify(message.toggleActuator, long + 1);
                        if (error)
                            return "toggleActuator." + error;
                    }
                }
                if (message.resetActuators != null && message.hasOwnProperty("resetActuators")) {
                    if (properties.op === 1)
                        return "op: multiple values";
                    properties.op = 1;
                    {
                        let error = $root.squarediot.v1.ResetActuatorsCmd.verify(message.resetActuators, long + 1);
                        if (error)
                            return "resetActuators." + error;
                    }
                }
                if (message.requestStatus != null && message.hasOwnProperty("requestStatus")) {
                    if (properties.op === 1)
                        return "op: multiple values";
                    properties.op = 1;
                    {
                        let error = $root.squarediot.v1.RequestStatusCmd.verify(message.requestStatus, long + 1);
                        if (error)
                            return "requestStatus." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Command message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.Command
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.Command} Command
             */
            Command.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.Command)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.Command();
                if (object.resetMetrics != null) {
                    if (typeof object.resetMetrics !== "object")
                        throw TypeError(".squarediot.v1.Command.resetMetrics: object expected");
                    message.resetMetrics = $root.squarediot.v1.ResetMetricsCmd.fromObject(object.resetMetrics, long + 1);
                }
                if (object.reboot != null) {
                    if (typeof object.reboot !== "object")
                        throw TypeError(".squarediot.v1.Command.reboot: object expected");
                    message.reboot = $root.squarediot.v1.RebootCmd.fromObject(object.reboot, long + 1);
                }
                if (object.setConfig != null) {
                    if (typeof object.setConfig !== "object")
                        throw TypeError(".squarediot.v1.Command.setConfig: object expected");
                    message.setConfig = $root.squarediot.v1.SetConfigCmd.fromObject(object.setConfig, long + 1);
                }
                if (object.setActuator != null) {
                    if (typeof object.setActuator !== "object")
                        throw TypeError(".squarediot.v1.Command.setActuator: object expected");
                    message.setActuator = $root.squarediot.v1.SetActuatorCmd.fromObject(object.setActuator, long + 1);
                }
                if (object.toggleActuator != null) {
                    if (typeof object.toggleActuator !== "object")
                        throw TypeError(".squarediot.v1.Command.toggleActuator: object expected");
                    message.toggleActuator = $root.squarediot.v1.ToggleActuatorCmd.fromObject(object.toggleActuator, long + 1);
                }
                if (object.resetActuators != null) {
                    if (typeof object.resetActuators !== "object")
                        throw TypeError(".squarediot.v1.Command.resetActuators: object expected");
                    message.resetActuators = $root.squarediot.v1.ResetActuatorsCmd.fromObject(object.resetActuators, long + 1);
                }
                if (object.requestStatus != null) {
                    if (typeof object.requestStatus !== "object")
                        throw TypeError(".squarediot.v1.Command.requestStatus: object expected");
                    message.requestStatus = $root.squarediot.v1.RequestStatusCmd.fromObject(object.requestStatus, long + 1);
                }
                return message;
            };

            /**
             * Creates a plain object from a Command message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.Command
             * @static
             * @param {squarediot.v1.Command} message Command
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Command.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (message.resetMetrics != null && message.hasOwnProperty("resetMetrics")) {
                    object.resetMetrics = $root.squarediot.v1.ResetMetricsCmd.toObject(message.resetMetrics, options);
                    if (options.oneofs)
                        object.op = "resetMetrics";
                }
                if (message.reboot != null && message.hasOwnProperty("reboot")) {
                    object.reboot = $root.squarediot.v1.RebootCmd.toObject(message.reboot, options);
                    if (options.oneofs)
                        object.op = "reboot";
                }
                if (message.setConfig != null && message.hasOwnProperty("setConfig")) {
                    object.setConfig = $root.squarediot.v1.SetConfigCmd.toObject(message.setConfig, options);
                    if (options.oneofs)
                        object.op = "setConfig";
                }
                if (message.setActuator != null && message.hasOwnProperty("setActuator")) {
                    object.setActuator = $root.squarediot.v1.SetActuatorCmd.toObject(message.setActuator, options);
                    if (options.oneofs)
                        object.op = "setActuator";
                }
                if (message.toggleActuator != null && message.hasOwnProperty("toggleActuator")) {
                    object.toggleActuator = $root.squarediot.v1.ToggleActuatorCmd.toObject(message.toggleActuator, options);
                    if (options.oneofs)
                        object.op = "toggleActuator";
                }
                if (message.resetActuators != null && message.hasOwnProperty("resetActuators")) {
                    object.resetActuators = $root.squarediot.v1.ResetActuatorsCmd.toObject(message.resetActuators, options);
                    if (options.oneofs)
                        object.op = "resetActuators";
                }
                if (message.requestStatus != null && message.hasOwnProperty("requestStatus")) {
                    object.requestStatus = $root.squarediot.v1.RequestStatusCmd.toObject(message.requestStatus, options);
                    if (options.oneofs)
                        object.op = "requestStatus";
                }
                return object;
            };

            /**
             * Converts this Command to JSON.
             * @function toJSON
             * @memberof squarediot.v1.Command
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Command.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Command
             * @function getTypeUrl
             * @memberof squarediot.v1.Command
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Command.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.Command";
            };

            return Command;
        })();

        v1.ResetMetricsCmd = (function() {

            /**
             * Properties of a ResetMetricsCmd.
             * @memberof squarediot.v1
             * @interface IResetMetricsCmd
             */

            /**
             * Constructs a new ResetMetricsCmd.
             * @memberof squarediot.v1
             * @classdesc Represents a ResetMetricsCmd.
             * @implements IResetMetricsCmd
             * @constructor
             * @param {squarediot.v1.IResetMetricsCmd=} [properties] Properties to set
             */
            function ResetMetricsCmd(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ResetMetricsCmd instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {squarediot.v1.IResetMetricsCmd=} [properties] Properties to set
             * @returns {squarediot.v1.ResetMetricsCmd} ResetMetricsCmd instance
             */
            ResetMetricsCmd.create = function create(properties) {
                return new ResetMetricsCmd(properties);
            };

            /**
             * Encodes the specified ResetMetricsCmd message. Does not implicitly {@link squarediot.v1.ResetMetricsCmd.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {squarediot.v1.IResetMetricsCmd} message ResetMetricsCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetMetricsCmd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ResetMetricsCmd message, length delimited. Does not implicitly {@link squarediot.v1.ResetMetricsCmd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {squarediot.v1.IResetMetricsCmd} message ResetMetricsCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetMetricsCmd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ResetMetricsCmd message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.ResetMetricsCmd} ResetMetricsCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetMetricsCmd.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.ResetMetricsCmd();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ResetMetricsCmd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.ResetMetricsCmd} ResetMetricsCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetMetricsCmd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ResetMetricsCmd message.
             * @function verify
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ResetMetricsCmd.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                return null;
            };

            /**
             * Creates a ResetMetricsCmd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.ResetMetricsCmd} ResetMetricsCmd
             */
            ResetMetricsCmd.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.ResetMetricsCmd)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                return new $root.squarediot.v1.ResetMetricsCmd();
            };

            /**
             * Creates a plain object from a ResetMetricsCmd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {squarediot.v1.ResetMetricsCmd} message ResetMetricsCmd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResetMetricsCmd.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ResetMetricsCmd to JSON.
             * @function toJSON
             * @memberof squarediot.v1.ResetMetricsCmd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResetMetricsCmd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ResetMetricsCmd
             * @function getTypeUrl
             * @memberof squarediot.v1.ResetMetricsCmd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ResetMetricsCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.ResetMetricsCmd";
            };

            return ResetMetricsCmd;
        })();

        v1.RebootCmd = (function() {

            /**
             * Properties of a RebootCmd.
             * @memberof squarediot.v1
             * @interface IRebootCmd
             * @property {number|null} [graceMs] RebootCmd graceMs
             */

            /**
             * Constructs a new RebootCmd.
             * @memberof squarediot.v1
             * @classdesc Represents a RebootCmd.
             * @implements IRebootCmd
             * @constructor
             * @param {squarediot.v1.IRebootCmd=} [properties] Properties to set
             */
            function RebootCmd(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * RebootCmd graceMs.
             * @member {number} graceMs
             * @memberof squarediot.v1.RebootCmd
             * @instance
             */
            RebootCmd.prototype.graceMs = 0;

            /**
             * Creates a new RebootCmd instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {squarediot.v1.IRebootCmd=} [properties] Properties to set
             * @returns {squarediot.v1.RebootCmd} RebootCmd instance
             */
            RebootCmd.create = function create(properties) {
                return new RebootCmd(properties);
            };

            /**
             * Encodes the specified RebootCmd message. Does not implicitly {@link squarediot.v1.RebootCmd.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {squarediot.v1.IRebootCmd} message RebootCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RebootCmd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.graceMs != null && Object.hasOwnProperty.call(message, "graceMs"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.graceMs);
                return writer;
            };

            /**
             * Encodes the specified RebootCmd message, length delimited. Does not implicitly {@link squarediot.v1.RebootCmd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {squarediot.v1.IRebootCmd} message RebootCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RebootCmd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RebootCmd message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.RebootCmd} RebootCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RebootCmd.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.RebootCmd();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.graceMs = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RebootCmd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.RebootCmd} RebootCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RebootCmd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RebootCmd message.
             * @function verify
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RebootCmd.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.graceMs != null && message.hasOwnProperty("graceMs"))
                    if (!$util.isInteger(message.graceMs))
                        return "graceMs: integer expected";
                return null;
            };

            /**
             * Creates a RebootCmd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.RebootCmd} RebootCmd
             */
            RebootCmd.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.RebootCmd)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.RebootCmd();
                if (object.graceMs != null)
                    message.graceMs = object.graceMs >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a RebootCmd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {squarediot.v1.RebootCmd} message RebootCmd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RebootCmd.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.graceMs = 0;
                if (message.graceMs != null && message.hasOwnProperty("graceMs"))
                    object.graceMs = message.graceMs;
                return object;
            };

            /**
             * Converts this RebootCmd to JSON.
             * @function toJSON
             * @memberof squarediot.v1.RebootCmd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RebootCmd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RebootCmd
             * @function getTypeUrl
             * @memberof squarediot.v1.RebootCmd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RebootCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.RebootCmd";
            };

            return RebootCmd;
        })();

        v1.SetConfigCmd = (function() {

            /**
             * Properties of a SetConfigCmd.
             * @memberof squarediot.v1
             * @interface ISetConfigCmd
             * @property {Object.<string,string>|null} [kv] SetConfigCmd kv
             */

            /**
             * Constructs a new SetConfigCmd.
             * @memberof squarediot.v1
             * @classdesc Represents a SetConfigCmd.
             * @implements ISetConfigCmd
             * @constructor
             * @param {squarediot.v1.ISetConfigCmd=} [properties] Properties to set
             */
            function SetConfigCmd(properties) {
                this.kv = {};
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetConfigCmd kv.
             * @member {Object.<string,string>} kv
             * @memberof squarediot.v1.SetConfigCmd
             * @instance
             */
            SetConfigCmd.prototype.kv = $util.emptyObject;

            /**
             * Creates a new SetConfigCmd instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {squarediot.v1.ISetConfigCmd=} [properties] Properties to set
             * @returns {squarediot.v1.SetConfigCmd} SetConfigCmd instance
             */
            SetConfigCmd.create = function create(properties) {
                return new SetConfigCmd(properties);
            };

            /**
             * Encodes the specified SetConfigCmd message. Does not implicitly {@link squarediot.v1.SetConfigCmd.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {squarediot.v1.ISetConfigCmd} message SetConfigCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetConfigCmd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.kv != null && Object.hasOwnProperty.call(message, "kv"))
                    for (let keys = Object.keys(message.kv), i = 0; i < keys.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.kv[keys[i]]).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SetConfigCmd message, length delimited. Does not implicitly {@link squarediot.v1.SetConfigCmd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {squarediot.v1.ISetConfigCmd} message SetConfigCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetConfigCmd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetConfigCmd message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.SetConfigCmd} SetConfigCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetConfigCmd.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.SetConfigCmd(), key, value;
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (message.kv === $util.emptyObject)
                                message.kv = {};
                            let end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = "";
                            while (reader.pos < end2) {
                                let tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7, long);
                                    break;
                                }
                            }
                            if (key === "__proto__")
                                $util.makeProp(message.kv, key);
                            message.kv[key] = value;
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetConfigCmd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.SetConfigCmd} SetConfigCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetConfigCmd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetConfigCmd message.
             * @function verify
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetConfigCmd.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.kv != null && message.hasOwnProperty("kv")) {
                    if (!$util.isObject(message.kv))
                        return "kv: object expected";
                    let key = Object.keys(message.kv);
                    for (let i = 0; i < key.length; ++i)
                        if (!$util.isString(message.kv[key[i]]))
                            return "kv: string{k:string} expected";
                }
                return null;
            };

            /**
             * Creates a SetConfigCmd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.SetConfigCmd} SetConfigCmd
             */
            SetConfigCmd.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.SetConfigCmd)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.SetConfigCmd();
                if (object.kv) {
                    if (typeof object.kv !== "object")
                        throw TypeError(".squarediot.v1.SetConfigCmd.kv: object expected");
                    message.kv = {};
                    for (let keys = Object.keys(object.kv), i = 0; i < keys.length; ++i) {
                        if (keys[i] === "__proto__")
                            $util.makeProp(message.kv, keys[i]);
                        message.kv[keys[i]] = String(object.kv[keys[i]]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a SetConfigCmd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {squarediot.v1.SetConfigCmd} message SetConfigCmd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetConfigCmd.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.objects || options.defaults)
                    object.kv = {};
                let keys2;
                if (message.kv && (keys2 = Object.keys(message.kv)).length) {
                    object.kv = {};
                    for (let j = 0; j < keys2.length; ++j) {
                        if (keys2[j] === "__proto__")
                            $util.makeProp(object.kv, keys2[j]);
                        object.kv[keys2[j]] = message.kv[keys2[j]];
                    }
                }
                return object;
            };

            /**
             * Converts this SetConfigCmd to JSON.
             * @function toJSON
             * @memberof squarediot.v1.SetConfigCmd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetConfigCmd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetConfigCmd
             * @function getTypeUrl
             * @memberof squarediot.v1.SetConfigCmd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetConfigCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.SetConfigCmd";
            };

            return SetConfigCmd;
        })();

        v1.SetActuatorCmd = (function() {

            /**
             * Properties of a SetActuatorCmd.
             * @memberof squarediot.v1
             * @interface ISetActuatorCmd
             * @property {number|null} [pin] SetActuatorCmd pin
             * @property {boolean|null} [on] SetActuatorCmd on
             */

            /**
             * Constructs a new SetActuatorCmd.
             * @memberof squarediot.v1
             * @classdesc Represents a SetActuatorCmd.
             * @implements ISetActuatorCmd
             * @constructor
             * @param {squarediot.v1.ISetActuatorCmd=} [properties] Properties to set
             */
            function SetActuatorCmd(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SetActuatorCmd pin.
             * @member {number} pin
             * @memberof squarediot.v1.SetActuatorCmd
             * @instance
             */
            SetActuatorCmd.prototype.pin = 0;

            /**
             * SetActuatorCmd on.
             * @member {boolean} on
             * @memberof squarediot.v1.SetActuatorCmd
             * @instance
             */
            SetActuatorCmd.prototype.on = false;

            /**
             * Creates a new SetActuatorCmd instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {squarediot.v1.ISetActuatorCmd=} [properties] Properties to set
             * @returns {squarediot.v1.SetActuatorCmd} SetActuatorCmd instance
             */
            SetActuatorCmd.create = function create(properties) {
                return new SetActuatorCmd(properties);
            };

            /**
             * Encodes the specified SetActuatorCmd message. Does not implicitly {@link squarediot.v1.SetActuatorCmd.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {squarediot.v1.ISetActuatorCmd} message SetActuatorCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetActuatorCmd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pin);
                if (message.on != null && Object.hasOwnProperty.call(message, "on"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.on);
                return writer;
            };

            /**
             * Encodes the specified SetActuatorCmd message, length delimited. Does not implicitly {@link squarediot.v1.SetActuatorCmd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {squarediot.v1.ISetActuatorCmd} message SetActuatorCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SetActuatorCmd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SetActuatorCmd message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.SetActuatorCmd} SetActuatorCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetActuatorCmd.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.SetActuatorCmd();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.pin = reader.uint32();
                            break;
                        }
                    case 2: {
                            message.on = reader.bool();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SetActuatorCmd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.SetActuatorCmd} SetActuatorCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SetActuatorCmd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SetActuatorCmd message.
             * @function verify
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SetActuatorCmd.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.pin != null && message.hasOwnProperty("pin"))
                    if (!$util.isInteger(message.pin))
                        return "pin: integer expected";
                if (message.on != null && message.hasOwnProperty("on"))
                    if (typeof message.on !== "boolean")
                        return "on: boolean expected";
                return null;
            };

            /**
             * Creates a SetActuatorCmd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.SetActuatorCmd} SetActuatorCmd
             */
            SetActuatorCmd.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.SetActuatorCmd)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.SetActuatorCmd();
                if (object.pin != null)
                    message.pin = object.pin >>> 0;
                if (object.on != null)
                    message.on = Boolean(object.on);
                return message;
            };

            /**
             * Creates a plain object from a SetActuatorCmd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {squarediot.v1.SetActuatorCmd} message SetActuatorCmd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SetActuatorCmd.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.pin = 0;
                    object.on = false;
                }
                if (message.pin != null && message.hasOwnProperty("pin"))
                    object.pin = message.pin;
                if (message.on != null && message.hasOwnProperty("on"))
                    object.on = message.on;
                return object;
            };

            /**
             * Converts this SetActuatorCmd to JSON.
             * @function toJSON
             * @memberof squarediot.v1.SetActuatorCmd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SetActuatorCmd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for SetActuatorCmd
             * @function getTypeUrl
             * @memberof squarediot.v1.SetActuatorCmd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            SetActuatorCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.SetActuatorCmd";
            };

            return SetActuatorCmd;
        })();

        v1.ToggleActuatorCmd = (function() {

            /**
             * Properties of a ToggleActuatorCmd.
             * @memberof squarediot.v1
             * @interface IToggleActuatorCmd
             * @property {number|null} [pin] ToggleActuatorCmd pin
             */

            /**
             * Constructs a new ToggleActuatorCmd.
             * @memberof squarediot.v1
             * @classdesc Represents a ToggleActuatorCmd.
             * @implements IToggleActuatorCmd
             * @constructor
             * @param {squarediot.v1.IToggleActuatorCmd=} [properties] Properties to set
             */
            function ToggleActuatorCmd(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ToggleActuatorCmd pin.
             * @member {number} pin
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @instance
             */
            ToggleActuatorCmd.prototype.pin = 0;

            /**
             * Creates a new ToggleActuatorCmd instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {squarediot.v1.IToggleActuatorCmd=} [properties] Properties to set
             * @returns {squarediot.v1.ToggleActuatorCmd} ToggleActuatorCmd instance
             */
            ToggleActuatorCmd.create = function create(properties) {
                return new ToggleActuatorCmd(properties);
            };

            /**
             * Encodes the specified ToggleActuatorCmd message. Does not implicitly {@link squarediot.v1.ToggleActuatorCmd.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {squarediot.v1.IToggleActuatorCmd} message ToggleActuatorCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ToggleActuatorCmd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pin != null && Object.hasOwnProperty.call(message, "pin"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.pin);
                return writer;
            };

            /**
             * Encodes the specified ToggleActuatorCmd message, length delimited. Does not implicitly {@link squarediot.v1.ToggleActuatorCmd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {squarediot.v1.IToggleActuatorCmd} message ToggleActuatorCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ToggleActuatorCmd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ToggleActuatorCmd message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.ToggleActuatorCmd} ToggleActuatorCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ToggleActuatorCmd.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.ToggleActuatorCmd();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.pin = reader.uint32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ToggleActuatorCmd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.ToggleActuatorCmd} ToggleActuatorCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ToggleActuatorCmd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ToggleActuatorCmd message.
             * @function verify
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ToggleActuatorCmd.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                if (message.pin != null && message.hasOwnProperty("pin"))
                    if (!$util.isInteger(message.pin))
                        return "pin: integer expected";
                return null;
            };

            /**
             * Creates a ToggleActuatorCmd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.ToggleActuatorCmd} ToggleActuatorCmd
             */
            ToggleActuatorCmd.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.ToggleActuatorCmd)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.squarediot.v1.ToggleActuatorCmd();
                if (object.pin != null)
                    message.pin = object.pin >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a ToggleActuatorCmd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {squarediot.v1.ToggleActuatorCmd} message ToggleActuatorCmd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ToggleActuatorCmd.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults)
                    object.pin = 0;
                if (message.pin != null && message.hasOwnProperty("pin"))
                    object.pin = message.pin;
                return object;
            };

            /**
             * Converts this ToggleActuatorCmd to JSON.
             * @function toJSON
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ToggleActuatorCmd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ToggleActuatorCmd
             * @function getTypeUrl
             * @memberof squarediot.v1.ToggleActuatorCmd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ToggleActuatorCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.ToggleActuatorCmd";
            };

            return ToggleActuatorCmd;
        })();

        v1.ResetActuatorsCmd = (function() {

            /**
             * Properties of a ResetActuatorsCmd.
             * @memberof squarediot.v1
             * @interface IResetActuatorsCmd
             */

            /**
             * Constructs a new ResetActuatorsCmd.
             * @memberof squarediot.v1
             * @classdesc Represents a ResetActuatorsCmd.
             * @implements IResetActuatorsCmd
             * @constructor
             * @param {squarediot.v1.IResetActuatorsCmd=} [properties] Properties to set
             */
            function ResetActuatorsCmd(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new ResetActuatorsCmd instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {squarediot.v1.IResetActuatorsCmd=} [properties] Properties to set
             * @returns {squarediot.v1.ResetActuatorsCmd} ResetActuatorsCmd instance
             */
            ResetActuatorsCmd.create = function create(properties) {
                return new ResetActuatorsCmd(properties);
            };

            /**
             * Encodes the specified ResetActuatorsCmd message. Does not implicitly {@link squarediot.v1.ResetActuatorsCmd.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {squarediot.v1.IResetActuatorsCmd} message ResetActuatorsCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetActuatorsCmd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified ResetActuatorsCmd message, length delimited. Does not implicitly {@link squarediot.v1.ResetActuatorsCmd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {squarediot.v1.IResetActuatorsCmd} message ResetActuatorsCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResetActuatorsCmd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ResetActuatorsCmd message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.ResetActuatorsCmd} ResetActuatorsCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetActuatorsCmd.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.ResetActuatorsCmd();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ResetActuatorsCmd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.ResetActuatorsCmd} ResetActuatorsCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResetActuatorsCmd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ResetActuatorsCmd message.
             * @function verify
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ResetActuatorsCmd.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                return null;
            };

            /**
             * Creates a ResetActuatorsCmd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.ResetActuatorsCmd} ResetActuatorsCmd
             */
            ResetActuatorsCmd.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.ResetActuatorsCmd)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                return new $root.squarediot.v1.ResetActuatorsCmd();
            };

            /**
             * Creates a plain object from a ResetActuatorsCmd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {squarediot.v1.ResetActuatorsCmd} message ResetActuatorsCmd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResetActuatorsCmd.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this ResetActuatorsCmd to JSON.
             * @function toJSON
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResetActuatorsCmd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ResetActuatorsCmd
             * @function getTypeUrl
             * @memberof squarediot.v1.ResetActuatorsCmd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ResetActuatorsCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.ResetActuatorsCmd";
            };

            return ResetActuatorsCmd;
        })();

        v1.RequestStatusCmd = (function() {

            /**
             * Properties of a RequestStatusCmd.
             * @memberof squarediot.v1
             * @interface IRequestStatusCmd
             */

            /**
             * Constructs a new RequestStatusCmd.
             * @memberof squarediot.v1
             * @classdesc Represents a RequestStatusCmd.
             * @implements IRequestStatusCmd
             * @constructor
             * @param {squarediot.v1.IRequestStatusCmd=} [properties] Properties to set
             */
            function RequestStatusCmd(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new RequestStatusCmd instance using the specified properties.
             * @function create
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {squarediot.v1.IRequestStatusCmd=} [properties] Properties to set
             * @returns {squarediot.v1.RequestStatusCmd} RequestStatusCmd instance
             */
            RequestStatusCmd.create = function create(properties) {
                return new RequestStatusCmd(properties);
            };

            /**
             * Encodes the specified RequestStatusCmd message. Does not implicitly {@link squarediot.v1.RequestStatusCmd.verify|verify} messages.
             * @function encode
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {squarediot.v1.IRequestStatusCmd} message RequestStatusCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RequestStatusCmd.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified RequestStatusCmd message, length delimited. Does not implicitly {@link squarediot.v1.RequestStatusCmd.verify|verify} messages.
             * @function encodeDelimited
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {squarediot.v1.IRequestStatusCmd} message RequestStatusCmd message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            RequestStatusCmd.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a RequestStatusCmd message from the specified reader or buffer.
             * @function decode
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {squarediot.v1.RequestStatusCmd} RequestStatusCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RequestStatusCmd.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.squarediot.v1.RequestStatusCmd();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a RequestStatusCmd message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {squarediot.v1.RequestStatusCmd} RequestStatusCmd
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            RequestStatusCmd.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a RequestStatusCmd message.
             * @function verify
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            RequestStatusCmd.verify = function verify(message, long) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    return "maximum nesting depth exceeded";
                return null;
            };

            /**
             * Creates a RequestStatusCmd message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {squarediot.v1.RequestStatusCmd} RequestStatusCmd
             */
            RequestStatusCmd.fromObject = function fromObject(object, long) {
                if (object instanceof $root.squarediot.v1.RequestStatusCmd)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                return new $root.squarediot.v1.RequestStatusCmd();
            };

            /**
             * Creates a plain object from a RequestStatusCmd message. Also converts values to other types if specified.
             * @function toObject
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {squarediot.v1.RequestStatusCmd} message RequestStatusCmd
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            RequestStatusCmd.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this RequestStatusCmd to JSON.
             * @function toJSON
             * @memberof squarediot.v1.RequestStatusCmd
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            RequestStatusCmd.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for RequestStatusCmd
             * @function getTypeUrl
             * @memberof squarediot.v1.RequestStatusCmd
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            RequestStatusCmd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/squarediot.v1.RequestStatusCmd";
            };

            return RequestStatusCmd;
        })();

        return v1;
    })();

    return squarediot;
})();

export { $root as default };
